import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import productSearchQuery from '~/graphql/productSearch.gql';
import { buildCategoryProductsQuery } from '~/helpers/extract-helper';

function fetchSearch(_x, _x2, _x3) {
  return _fetchSearch.apply(this, arguments);
}

function _fetchSearch() {
  _fetchSearch = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, keyword, query) {
    var locale, _buildCategoryProduct, offset, limit, sortBy, orderBy, filterBy, response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _buildCategoryProduct = buildCategoryProductsQuery(query), offset = _buildCategoryProduct.offset, limit = _buildCategoryProduct.limit, sortBy = _buildCategoryProduct.sortBy, orderBy = _buildCategoryProduct.orderBy, filterBy = _buildCategoryProduct.filterBy;
            _context.next = 4;
            return context.app.apolloProvider.defaultClient.query({
              query: productSearchQuery,
              variables: {
                variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
                locale: locale,
                keyword: keyword,
                offset: offset,
                limit: limit,
                sortBy: sortBy,
                orderBy: orderBy,
                filterBy: filterBy
              }
            });

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchSearch.apply(this, arguments);
}

export { fetchSearch as default };